import { Component, OnInit, Input } from '@angular/core';
import { ProcessDetailsObject } from 'src/app/models/orders/order-details-process/process-details/process-details-object.model';

@Component({
  selector: 'app-process-flow',
  templateUrl: './process-flow.component.html',
  styleUrls: ['./process-flow.component.css']
})
export class ProcessFlowComponent implements OnInit {

  private _processDetails: ProcessDetailsObject;
  @Input()
  get processDetails(): any {
    return this._processDetails;
  }
  set processDetails(value: any) {
    this._processDetails = value;
    this.ngOnInit();
  }
  startTooltip: string;
  endTooltip: string;
  startDate: Date;
  endDate: Date;

  constructor() { }


  ngOnInit() {
    if (!this.processDetails) {
      this.processDetails = ProcessDetailsObject.create();
    }

    this.startDate = this.processDetails.getStartDate();
    if (!this.processDetails.isFinished()) {
      this.endTooltip = 'El proceso no ha finalizado todavía';
    } else {
      this.endDate = this.processDetails.getEndDate();
      this.endTooltip = 'Fecha de finalización del proceso:\n';
    }

  }


}
